import I18n from 'i18n-js'

export default (): (() => void) => {
  const unsubscribe: Array<() => void> = []

  window.onDomLoad(($dom) => {
    const doc = $dom[0]
    const elements = doc.querySelectorAll<HTMLElement>(
      "[data-behaviour='show-last-sync-errors']"
    )
    const moreSyncErrorMessages: HTMLElement | null =
      doc.querySelector<HTMLElement>(
        "[data-behaviour='more-sync-error-messages']"
      )

    const switchErrorDropdown = (): void => {
      const chevronIcon = document.getElementById('sync-error-message-chevron')
      const syncErrorButton = document.getElementById(
        'sync-error-message-button'
      )

      if (!moreSyncErrorMessages || !syncErrorButton || !chevronIcon) {
        return
      }

      if (moreSyncErrorMessages.classList.contains('sf-hidden')) {
        moreSyncErrorMessages.classList.remove('sf-hidden')
        syncErrorButton.innerHTML = I18n.t('js.sync_errors.hide_multiple')
        chevronIcon.classList.remove('fa-chevron-down')
        chevronIcon.classList.add('fa-chevron-up')
      } else {
        moreSyncErrorMessages.classList.add('sf-hidden')
        syncErrorButton.innerHTML = I18n.t('js.sync_errors.show_multiple')
        chevronIcon.classList.remove('fa-chevron-up')
        chevronIcon.classList.add('fa-chevron-down')
      }
    }

    elements.forEach((element) => {
      element.addEventListener('click', switchErrorDropdown)
      unsubscribe.push((): void => {
        element.removeEventListener('click', switchErrorDropdown)
      })
    })
  })
  return () => {
    unsubscribe.forEach((fn) => fn())
  }
}
